export const renderButtons = (project) => {
    const { demoUrl, frontendUrl, backendUrl, codeUrl } = project;
    return (
    <>
        {demoUrl && (
            <a
            href={demoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-pink-600 px-4 py-2 rounded hover:bg-pink-700 transition duration-200 mr-4"
            >
                Demo
            </a>
        )}

        {frontendUrl && (
            <a
            href={frontendUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-600 transition duration-200 mr-4"
            >
                Frontend
            </a>
        )}

        {backendUrl && (
            <a
            href={backendUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-600 transition duration-200 mr-0"
            >
                Backend
            </a>
        )}

        {!frontendUrl && !backendUrl && (
            <a
            href={codeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-700 transition duration-200 mr-4"
            >
                Code
            </a>
        )}
        </>
    );
};